import React, { useEffect, useState } from "react";

import TableHeader from "./table_header";
import TableFilter from "./table_filter";
import CardsTableData from "./table_body";
import TableBodyMobile from "./table_body_sm";
import TableSettingDialog from "../dialogs/table_setting_dialog";
import * as _ from 'lodash'

import { 
  getDefaultSettings, 
  getTableCell, 
  getTableHeadings } from "../../constants/table_data";

const CardsTable = ({showHeader = true, 
  tableData = [], 
  flag = 'card',
  selectable = false, 
  selectedCards = [], 
  setSelectedCards,
  onClickRow}) => {

  const [data, setData] = useState([])
  const [tableSettings, setTableSettings] = useState(getDefaultSettings(flag));

  const [openSettings, setOpenSettings] = useState(false);
  const toggleSetting = (value) => setOpenSettings(value);

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = data.map((n) => n.cardNumber);
      setSelectedCards(newSelected);
      return;
    }
    setSelectedCards([]);
  };

  const handleRowClick = (event, cardNumber) => {
    if (selectable) {
      const selectedIndex = selectedCards.indexOf(cardNumber);
      let newSelected = [];
  
      if (selectedIndex === -1) {
        newSelected = newSelected.concat(selectedCards, cardNumber);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selectedCards.slice(1));
      } else if (selectedIndex === selectedCards.length - 1) {
        newSelected = newSelected.concat(selectedCards.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(
          selectedCards.slice(0, selectedIndex),
          selectedCards.slice(selectedIndex + 1),
        );
      }
  
      setSelectedCards(newSelected);
    } else if (onClickRow != null){
      onClickRow(cardNumber)
    }
  };

  const changeQuery = (searchValues = []) => {
    let newData = tableData
    searchValues.forEach(s => {
      if (!_.isEmpty(s.id) && !_.isEmpty(s.value)) {
        newData = newData.filter(d => (d[s.id] ?? '').toString().includes(s.value))
      }
    })
    setData(newData)
  }

  useEffect(() => {
    setData(tableData)
  }, [tableData])

  return (
    <div className={`main-table-container ${!showHeader ? 'border-none' : ''}`}>
      { showHeader && <TableHeader toggleSetting={toggleSetting}/> }
      { showHeader && <TableFilter filterOptions={getTableHeadings(flag)} changeQuery={changeQuery}/> }
      <div className="d-none d-sm-block" style={{marginBottom: '-1px'}}>
        <CardsTableData 
          table_data={data} 
          tableSettings={tableSettings} 
          tabelCellStyles={getTableCell(flag)}
          tableHeadings={getTableHeadings(flag)}
          selectable={selectable}
          selectedCards={selectedCards}
          handleSelectAllClick={handleSelectAllClick}
          handleRowClick={handleRowClick}/>
      </div>
      <div className="d-block d-sm-none">
        <TableBodyMobile 
          table_data={data} 
          tableSettings={tableSettings} 
          tableHeadings={getTableHeadings(flag)}
          selectable={selectable}
          selectedCards={selectedCards}
          handleRowClick={handleRowClick}/>
      </div>

      <TableSettingDialog 
        data={tableSettings} 
        tableHeadings={getTableHeadings(flag)}
        changeTableSetting={setTableSettings}
        openSettings={openSettings} 
        toggleSetting={toggleSetting}
      />
    </div>
  );
};

export default CardsTable;
